import React from 'react';
import { Alert, Card as BSCard, CardBody, CardHeader, Col, Form, Row } from 'reactstrap';
import { assert } from '../base/utils/assert';
import ErrAlert from '../base/components/ErrAlert';
import Misc from '../base/components/Misc';
import PropControl from '../base/components/PropControl';
import PropControlPercentage from '../base/components/propcontrols/PropControlPercentage';
import DataStore, { getDataPath } from '../base/plumbing/DataStore';
import { space, toTitleCase, encURI } from '../base/utils/miscutils';
import C from '../C';
import { getStatus } from '../base/data/DataClass';
import ActionMan from '../plumbing/ActionMan';
import BrandingEditor from './BrandingEditor';
import ListItems from './ListItems';
import KWorkflow from './KWorkflow';
import { getDataItem, setWindowTitle } from '../base/plumbing/Crud';
import KStatus from '../base/data/KStatus';
import Campaign from '../base/data/Campaign';
import Advert from '../base/data/Advert';
import List from '../base/data/List';
import SavePublishDeleteEtc, { confirmUserAction } from '../base/components/SavePublishDeleteEtc';
import LinkOut from '../base/components/LinkOut';
import { Tab, Tabs } from '../base/components/Tabs';
import SubCard from '../base/components/SubCard';
import Icon from '../base/components/Icon';
import PropControlList from '../base/components/propcontrols/PropControlList';

import { MondayLink } from './monday';
import ShareWidget from '../base/components/ShareWidget';
import Impact from '../base/data/Impact';
import DataItemBadge from '../base/components/DataItemBadge';
import ImpactSettingsControls from './ImpactSettingsControls';
import DeprecatedIHControls from './DeprecatedIHControls';

let dummy = PropControlList; // import

function CampaignPage() {
	const type = C.TYPES.Campaign;
	setWindowTitle(type);

	const blocked = Misc.CheckAccess({ can: 'editAdvert' });
	if (blocked) return blocked;

	const path = DataStore.getValue(['location', 'path']);
	const itemId = path[1];
	if (!itemId) {
		// HACK with video testimonials? Use-case - so we can find the video testimonials
		let filterFn = null;
		if (DataStore.getUrlValue("hasTestimonial")) {
			filterFn = c => c && c.localCharities && Object.values(c.localCharities).find(lc => lc.testimonial);
		}
		return <ListItems type={type} 
			filterWith={[C.TYPES.Advertiser,C.TYPES.Agency]} 
			createWith={[C.TYPES.Advertiser]} filterFn={filterFn}
			FilterControls={CampaignFilterControls} />;
	}
	// getornew?
	let action = DataStore.getUrlValue('action');
	const pvItem = ActionMan.getDataItem({ type, id: itemId, status: C.KStatus.DRAFT, swallow: true, action }); // swallow cos errors are shown below
	if (!pvItem.resolved) {
		return (<div><h1>{toTitleCase(type)}: {itemId}</h1><Misc.Loading /></div>);
	}
	if (pvItem.error) {
		return (<div><h1>{toTitleCase(type)}: {itemId}</h1><ErrAlert error={pvItem.error} /></div>);
	}
	const item = pvItem.value;
	setWindowTitle(item);

	return (
		<div className="">
			<h1>{toTitleCase(type)}: {item.name || itemId}</h1>
			<EditCampaign item={item} />
			<ShareWidget item={item} hasButton />
		</div>
	);
} // ./CampaignPage


function CampaignFilterControls() {
	return <Form inline>
		<PropControl type="search" prop="filter" label="Filter" />
		{/* TODO first set master=true/false <PropControl className="ml-3" type="select" prop="for" label="TODO For" 
			options={[null,'Adverts', 'Advertisers/Agencies']} 
		/> */}
		<PropControl className="ml-3" type="checkbox" prop="hasTestimonial" label="Only with video testimonials"
		// (ugly layout with inline, Jul 2021) help="Use this to find examples with charity testimonials" 			
		/>
	</Form>;
}

function ListAdvertsForCampaign({ item }) {
	Campaign.assIsa(item);
	const path = getDataPath({status:KStatus.DRAFT, type:"Campaign",id:item.id});
	let pvAds = Advert.fetchForCampaign({campaignId: item.id, status:KStatus.DRAFT});
	return (<BSCard><CardHeader>Campaign Adverts</CardHeader>
		<CardBody>
			<PropControl prop="showNonServed" path={path} type="checkbox" label="Show non-served ads (e.g. mocks)" 
				help={item.master && item.showNonServed && "This is the master campaign. Make sure to also set this on specific campaigns."} 
			/>
			<div className="gridbox gridbox-md-4">
				{pvAds.value? List.hits(pvAds.value).map(ad => {
					let adPath = getDataPath({status:KStatus.DRAFT, type:"Advert",id:ad.id});
					return (
					<SubCard key={ad.id} className={space("m-2",ad._hidden && "disabled")}>
						<div className='d-flex flex-row justify-content-between align-items-end'>
							<a href={(ad.format === "display" ? '/#displayad/' : '/#advert/')+encURI(ad.id)}>{ad.name || "unnamed"}</a>
							{ad.format === "display" && <code>Display ad</code>}
						</div>
						<PropControl type="checkbox" label="Hide from showcase?" prop="hideFromShowcase" path={adPath}
								help="Hides this ad from any showcasing. Applies to all pages that feature this ad, not just this page!"
						/>
						<div><small>ID: {ad.id}</small></div>
					</SubCard>
					);
				}
				) : <Misc.Loading />}
			</div>
		</CardBody>
	</BSCard>);
}


function EditCampaign({ item }) {
	const type = C.TYPES.Campaign;
	assert(item.id, item);
	const campaign = item;
	let campaignPath = getDataPath({ status: C.KStatus.DRAFT, type, id: item.id });

	// Fetch objects
	const status = KStatus.DRAFT;
	const isMaster = campaign.master;	
	let pvAdvertiser = campaign.vertiser && 
		getDataItem({type:"Advertiser", id:campaign.vertiser, status:"DRAFT"});
	let masterForAdvertiserId = pvAdvertiser?.value?.campaign;
	let pvMasterForAdvertiser = masterForAdvertiserId && getDataItem({type:"Campaign", id:masterForAdvertiserId, status:"DRAFT"});
	let pvAgency = campaign.agencyId && 
		getDataItem({type:"Agency", id:campaign.agencyId, status:"DRAFT"});
	let masterForAgencyId = pvAgency?.value?.campaign;
	let pvMasterForAgency = masterForAgencyId && getDataItem({type:"Campaign", id:masterForAgencyId, status:"DRAFT"});

	return (
		<div>
			ID: {item.id}<br />
			<Tabs activeTabId={DataStore.getUrlValue('tab')} setActiveTabId={t => DataStore.setUrlValue('tab', t)} >
				<Tab title="About">
					<PropControl label="Campaign Name" item={item} path={campaignPath} prop="name" />
					<ImpactOverviewLink item={item} type={C.TYPES.Campaign} />

					<MondayLink board="2643467896" item={item} path={campaignPath} type="Deal" />
					<PropControl label={"Job Number (if not "+item.id+")"} item={item} path={campaignPath} prop="jobNumber" type="text"
						help="This SHOULD be the same as the id. But if it isn't for some reason, then enter it here for search purposes." />
					
					<PropControl label="Advertiser" path={campaignPath} prop="vertiser" type="DataItem" itemType="Advertiser" 
						status={C.KStatus.PUB_OR_DRAFT} />

					<PropControl canCreate prop="agencyId" path={campaignPath} label="Agency" type="DataItem" itemType={C.TYPES.Agency} 
						status={C.KStatus.PUB_OR_DRAFT} />

					<PropControl label="Client campaign reference" path={campaignPath} prop="xref" 
						help="Optional. Use this e.g. to record a link with an account or a deal in your CRM" />

					<PropControl label prop="report" path={campaignPath}
						type="upload" help="Upload or link to the PCA report" />

					<SubCard>
						<Row>
							<Col>
								<PropControl label="Start" path={campaignPath.concat("topLineItem")} prop="start" type="date" />
							</Col><Col>
								<PropControl label="End" path={campaignPath.concat("topLineItem")} prop="end" type="date" />
							</Col>
						</Row>
						<Row><Col>
							<PropControl label="Budget (Gross Campaign Value)" path={campaignPath.concat("topLineItem","budget")} prop="total" type="Money" 
								help="The budget from the brand's perspective (i.e. before agency or adtech fees)" />
								</Col>
						</Row>
						<Row>
							<Col>
								<PropControl label="Donation Trigger" path={campaignPath.concat("dntnModel")} prop="input" type="select" 
									options={"CPM CPC CPCV CPA".split(" ")} />
							</Col>
							<Col><PropControlPercentage label="Donation Fraction" path={campaignPath.concat("dntnModel")} prop="fraction" type="percentage" 
								min={0} max={1} help="Use this if the donation is a % of the total budget" /></Col>
							<Col><PropControl label="Donation Per Input" path={campaignPath.concat("dntnModel")} prop="perInput" type="Money" 
								help="Use this if the donation is a fixed amount per input. E.g. £5 CPM (£5 per 1000 impressions) or £1 CPA (£1 per action)" />
							</Col>
							<Col><PropControl label="Max Donation" path={campaignPath} prop="maxDntn" type="Money" /></Col>
						</Row>
					</SubCard>

				</Tab>
				<Tab title="Adverts">
					
					<ListAdvertsForCampaign item={item} campaignId={item.id} />
				</Tab>

				<Tab title="Impact">
					<ImpactSettingsControls item={campaign} type={C.TYPES.Campaign} path={campaignPath}/>
					<DeprecatedIHControls campaign={campaign} campaignPath={campaignPath}/>
				</Tab>
				<Tab title="Green (deprecated)">
					<GreenMediaControls campaign={campaign} campaignPath={campaignPath} />
				</Tab>
				<Tab title="Design">
					<BrandingEditor entity={item} path={campaignPath} workflow={KWorkflow.ImpactHub} />

					<PropControl label="Case study .pdf link" path={campaignPath} prop="caseStudy" type="url"
						help="For campaigns with a case-study that can be shared."
					/>

					<DesignControls campaignPath={campaignPath} />

				</Tab>
			</Tabs>
			<SavePublishDeleteEtc type={type} id={item.id} sendDiff
				className=""
				position="relative"
				color="light"
				preDelete={confirmUserAction}
				size="lg"
			/>
		</div>
	);
}


/**
 * Store green impacts in offsets
 */
function GreenMediaControls({ campaign, campaignPath }) {
	return <>
		<LinkOut disabled={ ! campaign || ! campaign?.offsets?.length}
			href={`https://${C.SERVER_TYPE}my.good-loop.com/greendash?campaign=${encURI(campaign?.id)}`}>Green Media Dashboard</LinkOut>

		<Alert color='warning' size='sm'>We now use ImpactDebits</Alert>

		<PropControl label={<span>Kgs of CO<sub>2</sub></span>} 
			type="number" prop="co2" path={campaignPath} />
		
		<PropControl type="list" path={campaignPath} prop="offsets" Viewer={GreenMediaOffsetEditor} Editor={GreenMediaOffsetEditor} />
	</>;
}

function ImpactSmallView({path,item,i}) {
	return <DataItemBadge item={item} />;
}


function GreenMediaOffsetEditor({i, path, item}) {
	const unit = (item && item.name) || "tree(s)";
	return <SubCard>
		{i >= 0 && <h3>Impact {i+1}: {unit} {Impact.isDynamic(item) && "(dynamic)"}</h3>}
		<PropControl label="Impact partner" path={path} prop="charity" sort="id-asc"
			type="DataItem" itemType={C.TYPES.NGO} status={KStatus.PUBLISHED}
		/>
		<PropControl label="Output type" type="select" prop="name" path={path}
			options={["carbon offset", "tree(s)", "coral"]}
			help="Type of output for this offset"
		/>
		<PropControl label="Output rate" type="number" path={path} prop="rate"
			help="(Optional) Usualyy unset for fixed offsets. Units of output per unit input (eg trees per impression). Typically less than 1."
		/>
		<PropControl type="number" prop="n" path={path}
			label={<>{unit}: units planted/committed<Icon name="seedling" /></>}
		/>
		<PropControl label="Date" type="date" prop="date" path={path} />
		<PropControl label="Notes" type="textarea" prop="notes" path={path} />
	</SubCard>;
}



function DesignControls({ campaignPath }) {
	const headerImg = DataStore.getValue(campaignPath.concat('bg'));

	const warning = !headerImg && "A header image has not been assigned.";

	return <>
		<PropControl label="Header Image" type="imgUpload" prop="bg" path={campaignPath}
			help={<>
				This field is for the campaign page background header image (should be high-resolution as it will fit almost the entire screen).&nbsp;
				{warning && <span className="text-warning">{warning}</span>}
			</>}
		/>
		<PropControl label="Small Print" path={campaignPath} prop="smallPrint" help="This will appear in the bottom right corner of the campaign page." />
		<PropControl label="Custom CSS" path={campaignPath} type="code" lang="css" prop="customCss"/>
	</>;
}

/**
 * Link to overview page
 * @param {DataClass} item
 * @param {String} type
 */
export function ImpactOverviewLink({ item, type }) {
	assert(item && type);
	if (type === C.TYPES.Advertiser) type = "brand";
	const link = `${C.HTTPS}://${C.SERVER_TYPE}my.good-loop.com/impact/view/${type.toLowerCase()}/${encURI(item.id)}`;
	return <>Impact Overview <LinkOut href={link + "?gl.status=DRAFT"}>draft</LinkOut> | <LinkOut
		disabled={getStatus(item) === KStatus.DRAFT || getStatus(item) === KStatus.TRASH} href={link}>published</LinkOut></>;
}


export default CampaignPage;
